angular.module('core')
    .service('dblArrayService', [function() {

        /**
         * Rerturn an array containing the first n elements of array a.
         * If a is not an array or a.length <= n, returns a.
         * If n is null, undefined or not a finite number, returns a.
         *
         * @param {array} a - an array
         * @param {number} n - number of elements to return.
         **/
        function limit(a, n) {
            if (!a || n === null || !isFinite(n) || a.length <= n) {
                return a;
            }

            return a.slice(0, n);
        }

        return {
            limit: limit
        };
    }]
);
